import { render } from "./HiringManagerDropdown.vue?vue&type=template&id=70095d3d"
import script from "./HiringManagerDropdown.vue?vue&type=script&lang=js"
export * from "./HiringManagerDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__